import { Navigate, Outlet } from 'react-router-dom';
import { hasModulo } from './session';

const ModuleRoute = ({ modulo, fallback = '/' }) => {
  const modulos = Array.isArray(modulo) ? modulo : [modulo];
  const allowed = modulos.some((item) => hasModulo(item));
  if (!allowed) {
    return <Navigate to={fallback} replace />;
  }
  return <Outlet />;
};

export default ModuleRoute;
